<template>
  <div
    :class="{
      'border-t-0 border-l-0 border-r-0 last:border-b-0 rounded-none first:pt-1 last:pb-0 !px-1 pt-5 pb-3':
        props.noPanel,
      ' flex !items-start': props.vertAlignment,
    }"
    class="border border-solid border-racq-pale-blue-border rounded px-5 py-7 md:px-8 flex items-center justify-between gap-6"
  >
    <!-- Text block -->
    <div class="flex-1 pr-4">
      <h3 class="text-base-bold text-racq-dark-grey">{{ title }}</h3>
      <p class="text-sm text-racq-med-gray">{{ description }}</p>
      <slot name="otheractions"></slot>
    </div>

    <!-- FormKit toggle (label accessibility - add hidden content in wrapper and replace duplicate label with section schema span) -->
    <FormKit
      type="nativeToggle"
      :value="modelValue"
      :disabled="disabled"
      :label="labelValue"
      :sectionsSchema="sectionSchemaToggleLabel"
      @input="onInput"
      ><span class="sr-only">{{ labelValue }}</span></FormKit
    >
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from 'vue';
import { FormKit } from '@formkit/vue';
import { OFF, ON } from '@/constants/general-words.const';
import { IToggleSwitchCardItem } from '@/interfaces/components/toggle-switch-card.interface';

const props = defineProps<IToggleSwitchCardItem>();
const labelValue = computed(() => (props?.modelValue ? ON : OFF));
const sectionSchemaToggleLabel = {
  label: {
    $el: 'span',
    attrs: {
      'aria-label': 'Enable notifications',
    },
  },
};

const emit = defineEmits<{
  /** For v-model support */
  (e: 'update:modelValue', value: boolean): void;
  /** To inform parent which id changed and its new value */
  (e: 'change', payload: { id: string; value: boolean }): void;
}>();

function onInput(value: boolean) {
  emit('update:modelValue', value);
  emit('change', { id: props.id, value });
}
</script>
